export default __webpack_public_path__ + "static/media/balance-auto-accepted-declined.661aa92a.md";